import {
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@us/Store/CustomHandlerCreator";
import { DocumentSearchParameters } from "@us/Services/DocumentSearch/DocumentSearchService";
import { DocumentSearchPageParameterModel } from "@us/Store/Data/DocumentSearchPage/DocumentSearchPageState";

type HandlerType = CustomApiHandler<DocumentSearchParameters, DocumentSearchPageParameterModel>;

export const PopulateApiParameter: HandlerType = (props: any) => {
    props.apiParameter = props.parameter;
};

export const SetDocumentSearchData: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/DocumentSearchData/SetDocumentSearchData",
        result: props.parameter,
    });
};

export const chain = [PopulateApiParameter, SetDocumentSearchData];

const documentSearchFilterHandler = createHandlerChainRunner(chain, "DocumentSearchFilterHandler");
export default documentSearchFilterHandler;